export default [{
    name: 'teacher-dashboard',
    path: '/teacher-dashboard',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/TeacherDashboard'),
    meta: {
        requiresAuth: true
    }
},

{
    name: 'class-tasks',
    path: '/class-tasks',
    component: () => import( /* webpackChunkName: "chunks/class-tasks" */ '@views/teachers/ClassTasksView'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'teacher-profile',
    path: '/profile',
    component: () => import( /* webpackChunkName: "chunks/teachers/profile" */ '@views/teachers/Profile'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'teacher-messenger',
    path: '/messenger/:class_id?/:user_id?',
    component: () => import( /* webpackChunkName: "chunks/teachers/Messenger" */ '@views/teachers/Messenger/Messenger'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'hod-dashboard',
    path: '/hod-dashboard',
    component: () => import( /* webpackChunkName: "chunks/hod-dashboard" */ '@views/HodDashboard'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'show-notifications',
    path: '/show/notifications',
    component: () => import( /* webpackChunkName: "chunks/notifications" */ '@views/notifications/NotificationsList'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'hod-announcements',
    path: '/hod/announcements',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/school_ads/SchoolAdsList'),
    meta: {
        requiresAuth: true
    },
},
{
    name: "teacher-incidents",
    path: "/teacher-incidents",
    component: () =>
        import(
                /* webpackChunkName: "chunks/incidents" */ "@views/teachers/incidents/IncidentList"
        ),
    meta: {
        requiresAuth: true,
    },
},
{
    name: "teacher-incidents-create",
    path: "/teacher-incidents/create",
    component: () =>
        import(
                /* webpackChunkName: "chunks/teacher-dashboard" */ "@views/teachers/incidents/IncidentFormNew"
        ),
    meta: {
        requiresAuth: true,
    },
},

{
    name: "teacher-incidents-edit",
    path: "/teacher-incidents/edit/:id",
    component: () =>
        import(
                /* webpackChunkName: "chunks/teacher-dashboard" */ "@views/teachers/incidents/IncidentFormNew"
        ),
    meta: {
        requiresAuth: true,
    },
},
{
    name: 'hod-weekly-plans',
    path: '/hod/weekly-plans',
    component: () => import( /* webpackChunkName: "chunks/weekly-plans" */ '@views/weekly_plans/WeeklyPlansList'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'hod-trips',
    path: '/hod/trips',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/trips/TeacherTripsRequests'),
    meta: {
        requiresAuth: true
    },
},
{
    name: 'teacher-trips',
    path: '/teacher/trips',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/trips/TripList'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'teacher-pickup-requests',
    path: '/teacher/pickup-requests',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/pickup_requests/PickUpRequestList'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'homework_projects',
    path: '/homeworks',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/teachers/tabs/plans_tabs/Homework'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'homework_details',
    path: '/homework-details/:id',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/Homeworks/homeworkDetail'),
    meta: {
        requiresAuth: true
    }
},
{
    name: 'add_homework',
    path: '/add-homework',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/Homeworks/homeworkForm'),
    meta: {
        requiresAuth: true
    }

},
{
    name: 'edit_homework',
    path: '/edit-homework/:id',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/Homeworks/homeworkForm'),
    meta: {
        requiresAuth: true
    }

},
{
    name: '/AccessStudentsList',
    path: '/teacher/trip/access_students/:id',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/trips/AccessStudentsList'),
    meta: {
        requiresAuth: true
    },
    props: true
},
{
    name: 'skill-gradebook',
    path: '/skill-gradebook',
    component: () => import( /* webpackChunkName: "chunks/teacher-dashboard" */ '@views/teachers/skill_grade_book/Grades'),
    meta: {
        requiresAuth: true
    }
},
    // {
    //     name: "ib-report",
    //     path: "/ib-report",
    //     component: () =>
    //         import(
    //         /* webpackChunkName: "chunks/ib-report" */ "@views/gradebook_reports/IBReport"
    //         ),
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
];